import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, Button, CardContent, CardHeader, FormControlLabel, Switch, Select, MenuItem, FormControl, InputLabel,
} from '@material-ui/core';
import {
  Props,
} from './types';
import { ColorPalette } from '../../widgets/TitleWidget/types';
import styles from './styles.module.scss';

const TabWidgetCard: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.handleChangeData('textColor', ColorPalette.primary)
  },[])
  return (
    (
      <>
        <CardContent>
          <TextField
            value={props.focusedWidgetData.params.title || ''}
            onChange={(event) => props.handleChangeData('title', event.target.value)}
            autoFocus
            margin="dense"
            id="widgetTitle"
            label="Widget Title"
            fullWidth
          />

          <FormControl variant="outlined" className={styles.formControl}>
            <InputLabel>Title Color</InputLabel>
            <Select
              label="Title Color"
              onChange={(event) => props.handleChangeData('textColor', event.target.value)}
              value={props.focusedWidgetData.params.textColor || ''}
            >
              {Object.values(ColorPalette).map((cp: string) => <MenuItem key={cp} value={cp}>{cp}</MenuItem>)}
            </Select>
          </FormControl>
        </CardContent>
      </>
    )
  );
};

export default TabWidgetCard;

